import styled from 'styled-components'
import { LinkStyle } from '../layout'

const LinkButton = styled.button`
  ${LinkStyle}

  font-size: 1rem;
  padding: 0;
  border: 0;
  background-color: transparent;
`

export default LinkButton
